import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getToken} from '../libs/util'

import * as dd from 'dingtalk-jsapi/entry/union';
import ddBizNavigationSetTitle from 'dingtalk-jsapi/api/biz/navigation/setTitle';

Vue.use(Router)

const shopId = process.env.NODE_ENV === 'production' ? store.state.shop.id : 1
let routes = [
  {
    path: '/article/list',
    meta: {},
    component: () => import('@/views/article/list')
  },
  {
    name: 'noAccount',
    path: '/noAccount',
    meta: {},
    component: () => import('@/views/noAccount')
  },
  {
    name: 'firstVerify',
    path: '/firstVerify',
    meta: {
      title: '店员验证'
    },
    component: () => import('@/views/firstVerify')
  },
  {
    path: '/article/detail',
    meta: {},
    component: () => import('@/views/article/detail')
  },
  {
    name: 'login-weixin',
    path: '/login-weixin',
    meta: {
      title: '微信登录'
    },
    component: () => import('@/views/login-weixin')
  },
  {
    name: 'login-dingtalk',
    path: '/login-dingtalk',
    meta: {
      title: '钉钉登录'
    },
    component: () => import('@/views/login-dingtalk')
  },
  {
    name: 'set-token',
    path: '/set-token',
    meta: {
      title: '请稍候'
    },
    component: () => import('@/views/set-token')
  },
  {
    name: 'clear-storage',
    path: '/clear-storage',
    meta: {
      title: '清除storage'
    },
    component: () => import('@/views/clear-storage')
  },
  {
    path: '/featnet',
    meta: {
      title: '汕头飞鸟网络'
    },
    component: () => import('@/views/featnet')
  },
  {
    path: '/toAlipay/:type/:no',
    name: 'to-alipay',
    meta: {
      title: '前往支付宝',
    },
    component: () => import('@/views/toAlipay')
  },
]
//录入路由路径
const defaultRoutes = require('./routes-default').default
let routeMap = new Map()
let defaultRouteMap = new Map()
defaultRoutes.forEach(route => {
  defaultRouteMap.set(route.path, route)
  routeMap.set(route.path, route)
})
try {
  const specificRoutes = require(`./routes-${shopId}`).default
  specificRoutes.forEach(route => {
    routeMap.set(route.path, route)
  })
} catch (e) {
}
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: routes.concat(Array.from(routeMap.values()))
})

const token = getToken();
const authCheck = (to, next) => {
  if(['register', 'login-weixin', 'login-dingtalk', 'set-token', 'clear-storage', 'noAccount', 'firstVerify','to-alipay'].indexOf(to.name) == -1){
    if(token == null || token == ''){
      const shop = store.state.shop
      if (shop.platform == store.state.ShopPlatformEnum.WEIXIN.value) {  // 微信接单
        next({
          path: '/login-weixin',
          query: {
            uri: to.fullPath
          }
        })
      } else if (shop.platform == store.state.ShopPlatformEnum.DINGTALK.value) {  // 钉钉接单
        const ddConfig = store.state.ddConfig
        next({
          path: '/login-dingtalk',
          query: {
            corpId: ddConfig.corpId
          }
        })
      } else {
        alert('未知接单平台：'+ shop.platform)
      }
    }else{
      if(store.state.roles){
        if(store.state.isRequireVerify){
          if(to.name !== 'account-verify'){
            next({
              path: '/account-verify'
            })
            return;
          }
        }else if(to.name === 'account-verify'){
          next('/')
          return;
        }
        next();
      }else{
        store.dispatch('getAccountRoles').then(()=>{
          authCheck(to,next)
        }).catch((err) => {
          alert(err)
        })
      }
    }
  }else{
    if(to.name === 'firstVerify' && Vue.prototype.$hasFeature('new_account_manage')){
      next({
              path: '/account-verify'
      })
    }else{
      next();
    }
  }
}

router.beforeEach((to, from, next) => {
  authCheck(to, next)
})

// 附加功能路由校验
let featureMap = new Map()
featureMap.set('/clerk/post/list', 'post_list')
featureMap.set('/leader/clerk-post-check-list', 'post_list')
featureMap.set('/clerk/auto/online', 'auto_online')
featureMap.set('/clerk/gift', 'gift_wall')
featureMap.set('/kf/order-entry', 'order_entry_list')
router.beforeEach((to,from,next)=>{
  if (featureMap.has(to.path)) {
    if (!(store.state.featureValue && store.state.featureValue.has(featureMap.get(to.path)))) {
      alert('店铺未开通该附加功能,请联系管理员')
      next({path:from.path})
      return false
    }
  }
  next()
})

router.afterEach((to, from) => {
  // 页面标题替换店员和工资标签
  if (to.meta.title && store.state.label) {
    if (to.meta.title.indexOf('店员') != -1) {
      to.meta.title = to.meta.title.replace(/店员/g, store.state.label.clerkLabel)
    }
    if (to.meta.title.indexOf('工资') != -1) {
      to.meta.title = to.meta.title.replace(/工资/g, store.state.label.salaryLabel)
    }
  }
  const title = to.meta.title || store.state.shop.name
  if (store.state.shop.platform == store.state.ShopPlatformEnum.DINGTALK.value) {
    dd.ready(() => {
      ddBizNavigationSetTitle({
        title: title
      })
    })
  } else {
    document.title = title
  }
})

export default router
